import PharmacistInquiryForm from '@component_path/pages/pc/positions/show/inquiry_form/pharmacist';
import AgeParts from '@component_path/lib/ageParts';
import initShowPage from '@component_path/pages/pc/positions/show/initShowPage.js';
import mapboxEmbed from '@component_path/shared/mapboxEmbed';

document.addEventListener('DOMContentLoaded', () => {
  initShowPage(PharmacistInquiryForm, AgeParts.createBirthYears());
  mapboxEmbed();
});